// "Which One Piece Character Are You?" — personality quiz data.
// Each answer awards points to characters; highest total wins.

export const RESULTS = {
  luffy: {
    name: 'Monkey D. Luffy', slug: 'monkey-d-luffy',
    image: 'https://cdn.myanimelist.net/images/characters/9/310307.jpg',
    tagline: 'The Free Spirit',
    blurb: "You live for adventure and freedom. Rules bore you, food excites you, and you'd cross the whole ocean for a friend. People follow you because your heart is enormous.",
  },
  zoro: {
    name: 'Roronoa Zoro', slug: 'roronoa-zoro',
    image: 'https://cdn.myanimelist.net/images/characters/3/100534.jpg',
    tagline: 'The Loyal Blade',
    blurb: "Disciplined, stubborn, and ride-or-die loyal. You live by your own code, train harder than anyone, and never break a promise — even if you get lost on the way there.",
  },
  nami: {
    name: 'Nami', slug: 'nami',
    image: 'https://cdn.myanimelist.net/images/characters/6/59914.jpg',
    tagline: 'The Clever Navigator',
    blurb: "Sharp, ambitious, and three steps ahead. You read people and situations fast, you know what you want, and you'll get your crew out of any storm (for a fair price).",
  },
  sanji: {
    name: 'Vinsmoke Sanji', slug: 'vinsmoke-sanji',
    image: 'https://cdn.myanimelist.net/images/characters/5/136769.jpg',
    tagline: 'The Passionate Heart',
    blurb: "Fiery, caring, and loyal to a fault. You'd never let a friend go hungry or a fight go unanswered. You feel everything deeply and protect the people you love.",
  },
  usopp: {
    name: 'Usopp', slug: 'usopp',
    image: 'https://cdn.myanimelist.net/images/characters/16/188076.jpg',
    tagline: 'The Brave Underdog',
    blurb: "Creative, funny, and braver than you give yourself credit for. You're the heart and humor of the group, and when it really counts, you always come through.",
  },
  chopper: {
    name: 'Tony Tony Chopper', slug: 'tony-tony-chopper',
    image: 'https://cdn.myanimelist.net/images/characters/3/100536.jpg',
    tagline: 'The Gentle Healer',
    blurb: "Kind, curious, and pure-hearted. You care for everyone around you and want to make the world a little less cruel. Don't let anyone mistake your kindness for weakness.",
  },
  robin: {
    name: 'Nico Robin', slug: 'nico-robin',
    image: 'https://cdn.myanimelist.net/images/characters/16/363700.jpg',
    tagline: 'The Quiet Seeker',
    blurb: "Calm, mysterious, and endlessly curious. You chase truth and knowledge, you've survived things others couldn't, and your stillness hides real strength.",
  },
  law: {
    name: 'Trafalgar Law', slug: 'trafalgar-law',
    image: 'https://cdn.myanimelist.net/images/characters/10/258757.jpg',
    tagline: 'The Cool Strategist',
    blurb: "Calculating, composed, and always playing the long game. You keep your cards close, think two moves ahead, and you're loyal to the few who earn it.",
  },
  ace: {
    name: 'Portgas D. Ace', slug: 'portgas-d-ace',
    image: 'https://cdn.myanimelist.net/images/characters/2/72220.jpg',
    tagline: 'The Brave Big Brother',
    blurb: "Warm, fearless, and fiercely protective. You'd throw yourself in harm's way for the people you love, and your loyalty burns brighter than any flame.",
  },
  shanks: {
    name: 'Shanks', slug: 'shanks',
    image: 'https://cdn.myanimelist.net/images/characters/9/307639.jpg',
    tagline: 'The Easygoing Legend',
    blurb: "Laid-back but commanding. You don't sweat the small stuff, you bring people together, and everyone respects you without you ever raising your voice.",
  },
  hancock: {
    name: 'Boa Hancock', slug: 'boa-hancock',
    image: 'https://cdn.myanimelist.net/images/characters/14/146013.jpg',
    tagline: 'The Proud Empress',
    blurb: "Confident, bold, and impossible to ignore. You know your worth, you command any room you enter, and beneath the pride is fierce loyalty to your own.",
  },
  mihawk: {
    name: 'Dracule Mihawk', slug: 'dracule-mihawk',
    image: 'https://cdn.myanimelist.net/images/characters/7/69747.jpg',
    tagline: 'The Solitary Master',
    blurb: "Focused, self-reliant, and always chasing mastery. You walk your own path, need no one's approval, and you measure yourself only against the very best.",
  },
};

// Every character below appears in exactly 5 answer options, and that balance is
// the whole quiz. Luffy used to be listed in 8 options while Shanks, Usopp and
// Hancock were in 3, so answering at random returned Luffy 32% of the time and
// Shanks 0.1%. If you add or reword an answer, keep the counts level —
// characterMatchQuiz.test.js fails the build if they drift.
export const QUESTIONS = [
  {
    q: "What's your real dream?",
    options: [
      { text: 'Total freedom and adventure', scores: ['luffy', 'shanks'] },
      { text: 'To become the strongest there is', scores: ['zoro', 'mihawk'] },
      { text: 'To uncover the truth of the world', scores: ['robin', 'nami'] },
      { text: 'To protect everyone I love', scores: ['sanji', 'chopper', 'ace'] },
    ],
  },
  {
    q: 'Pick a way to fight:',
    options: [
      { text: 'Charge in head-first', scores: ['luffy', 'ace'] },
      { text: 'Pure skill and steel', scores: ['zoro', 'mihawk'] },
      { text: 'Outsmart them', scores: ['law', 'nami', 'usopp'] },
      { text: 'Stand between them and my friends', scores: ['sanji', 'chopper', 'shanks'] },
    ],
  },
  {
    q: 'Your crew sees you as the...',
    options: [
      { text: 'Fearless leader', scores: ['luffy', 'shanks', 'hancock'] },
      { text: 'Reliable muscle', scores: ['zoro'] },
      { text: 'Schemer and planner', scores: ['nami', 'law'] },
      { text: 'Heart of the group', scores: ['chopper', 'usopp'] },
    ],
  },
  {
    q: 'You find a treasure chest. You...',
    options: [
      { text: 'Rip it open for the thrill', scores: ['ace'] },
      { text: 'Count every last coin', scores: ['nami', 'hancock'] },
      { text: 'Study it for clues and history', scores: ['robin', 'law'] },
      { text: 'Make sure everyone shares it', scores: ['shanks', 'chopper'] },
    ],
  },
  {
    q: "What's your biggest flaw?",
    options: [
      { text: 'Way too reckless', scores: ['luffy', 'ace'] },
      { text: 'Stubborn (and bad with directions)', scores: ['zoro'] },
      { text: 'A little greedy', scores: ['nami', 'hancock'] },
      { text: 'I panic — then do it anyway', scores: ['usopp'] },
    ],
  },
  {
    q: 'A rare day off. You...',
    options: [
      { text: 'Eat a feast and nap', scores: ['zoro'] },
      { text: 'Curl up with a book', scores: ['robin'] },
      { text: 'Cook for everyone', scores: ['sanji'] },
      { text: 'Train alone, no distractions', scores: ['mihawk'] },
    ],
  },
  {
    q: 'Someone insults your friend. You...',
    options: [
      { text: 'Punch them, no questions', scores: ['luffy'] },
      { text: 'Cold stare, then end it', scores: ['law', 'mihawk', 'hancock'] },
      { text: 'Step in front to shield them', scores: ['sanji'] },
      { text: 'Quietly plan their downfall', scores: ['robin', 'usopp'] },
    ],
  },
  {
    q: 'Pick your vibe:',
    options: [
      { text: 'Sunny and loud', scores: ['usopp'] },
      { text: 'Cool and quiet', scores: ['law', 'mihawk'] },
      { text: 'Elegant and proud', scores: ['hancock', 'robin'] },
      { text: 'Warm and caring', scores: ['chopper', 'ace', 'shanks', 'sanji'] },
    ],
  },
];
